<template>
  <!--begin::Footer-->
  <div
    class="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6"
    id="kt_app_sidebar_footer"
  >
      <a id="kt_help_toggle"
         class="btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100 ct-btn-aes"
         data-bs-toggle="tooltip"
         data-bs-placement="left"
         data-bs-dismiss="click"
         data-bs-trigger="hover">
          <span class="icon">
              <img src="/assets/img-fix/icon/icon_chat.svg" alt="">
          </span>
          <span class="btn-label">Hướng dẫn & Hỗ trợ</span>
          <KTIcon icon-name="document" icon-class="btn-icon fs-2 m-0" />
      </a>
  </div>
  <!--end::Footer-->
</template>

<script lang="ts">
import { getAssetPath } from "@/core/helpers/assets";
import { defineComponent } from "vue";

export default defineComponent({
  name: "sidebar-footer",
  components: {},
  setup() {
    return {
      getAssetPath,
    };
  },
});
</script>
